import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';

import {
  ComparisonObject,
  ComparisonObjectsWithLogicalOperators,
} from 'src/app/core/api/models';
import { DynamicTableService } from 'src/app/core/services/dynamic-table.service';
import { BaseFormPageComponent } from 'src/app/pages/shared/base/components/base-form-page.component';
import { FieldSearcherOutput } from 'src/app/shared/global/field-searcher/field-searcher-event.model';

@Component({
    selector: 'app-private-number-price-filter-form',
    templateUrl: './private-number-price-filter-form.component.html',
    styleUrls: ['./private-number-price-filter-form.component.scss'],
    standalone: false
})
export class PrivateNumberPriceFilterFormComponent
  extends BaseFormPageComponent
  implements OnInit
{
  //#region properties

  comparisonObjects: ComparisonObjectsWithLogicalOperators[] = [];
  @Input() tableComparisons: ComparisonObject[] = [];
  @Output('comparisonObjects') output_comparisonObject = new EventEmitter<
    ComparisonObjectsWithLogicalOperators[]
  >();
  resetEvent: any;

  fields: string = 'pages.privateNumbersPrice.form.fields.';

  //#endregion

  constructor(protected dynamicTableService: DynamicTableService) {
    super();
  }

  ngOnInit(): void {
    this.initForm();
  }

  initForm() {
    this.form = new FormGroup({
      title: new FormControl(''),
      numberOfDigits: new FormControl(''),
      reservationPeriod: new FormControl(''),
      isRound: new FormControl(''),
      smsCp: new FormControl(''),
      price: new FormControl(''),
    });
  }

  getComparisonObject(event: FieldSearcherOutput) {
    const fieldName = event.fieldName;
    delete event.fieldName;

    this.comparisonObjects =
      this.dynamicTableService.addOrRemoveComparisonObject(
        this.comparisonObjects,
        event,
        fieldName
      );
  }

  emitComparisons() {
    this.output_comparisonObject.emit(this.comparisonObjects);
  }

  onSearch() {
    this.emitComparisons();
  }

  onReset(event?) {
    this.resetEvent = event;
    this.comparisonObjects = [];
    this.emitComparisons();
  }
}
